import type { z } from 'zod'

import i18next from 'i18next'

export const requiredFieldError = 'Required' as const
export type ZodRequired = typeof requiredFieldError

function isInvalidRequired(issue: z.ZodInvalidTypeIssue): boolean {
	if (issue.received === 'undefined') {
		return true
	}
	if (issue.expected === 'number' && issue.received === 'nan') {
		return true
	}
	return false
}

export const errorMap: z.ZodErrorMap = (issue: z.ZodIssueOptionalMessage) => {
	switch (issue.code) {
		case 'too_small': {
			const { minimum, type } = issue
			const message =
				type === 'number'
					? i18next.t('validation-message-number-minimum', {
							minimum,
						})
					: i18next.t('validation-message-string-length-minimum', {
							minimum,
						})
			return {
				message,
			}
		}
		case 'too_big': {
			const { maximum, type } = issue
			const message =
				type === 'number'
					? i18next.t('validation-message-number-maximum', {
							maximum,
						})
					: i18next.t('validation-message-string-length-maximum', {
							maximum,
						})
			return {
				message,
			}
		}
		case 'invalid_type': {
			const message = isInvalidRequired(issue)
				? requiredFieldError
				: i18next.t('validation-message-invalid-type')
			return {
				message,
			}
		}
		default:
			return {
				message: i18next.t('validation-message-unknown-error'),
			}
	}
}
